import { filters } from "../../components/Filters/Filters.ts";
import { pagination } from "../../components/Pagination/Pagination";

(function () {
    if (document.querySelectorAll(".js-general-meetings-listing-page").length > 0) {

        const generalMeetingsListingPage = {
            init: function () {
                filters.init();
                filters.get(window.location.search);
                pagination.init();
                generalMeetingsListingPage.addEventListeners();
            },
            addEventListeners: () => {
                const filterSubmit = document.getElementById("filter-submit");

                if (filterSubmit) {
                    filterSubmit.addEventListener("click", (e) => {
                        e.preventDefault();

                        window.location.search = filters.set();
                    })
                }
            }
        };

        generalMeetingsListingPage.init();
    }
})();
